export enum NotificationType {
    COMUNICATION = 'communication',
    REQUESTED_EMAIL = 'requested_email',
}
